import React from 'react'
import CardContainer from '../../../Shared/Card/CardContainer';
import AnimatedExclamation from '../../../Shared/Animation/AnimatedExclamation'
import { bowl_icon } from '../../../Shared/icons'
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm'
import { LoadingComponent, LoadingButton } from 'usbc-web-react-library';
import { config } from '../../../../config';
import { useParams } from "react-router-dom"
import { currencyFormat } from '../../../Shared/helpers'
import useApi from '../../../../hooks/useApi'
import './ReviewAndPay.css'

function ReviewAndPay(props) {
    const [paymentOptions, setPaymentOptions] = React.useState(null);
    const [paymentProcessing, setPaymentProcessing] = React.useState(false);
 const [stripeKey, setStripeKey] =  React.useState(null);
    const [stripePromise, setStripePromise] = React.useState(null);

    const {
        fetchData: createPaymentIntent,
        response: paymentIntentResult,
        loading: isLoading,
    } = useApi();

    let { lid, season } = useParams();

    React.useEffect(() => {
        createPaymentIntent({
            url: 'createpaymentintent', method: 'POST', body:
            {
                LeagueId: lid,
                MemberId: props.wizardState?.memberId,
                Season: Number(season),
                ProductId: props.wizardState?.productId,
                BowlerInfo: props.wizardState?.bowlerProfile
            }
        }).then(result => {
            if (result.clientSecret)
                setPaymentOptions({
                    // passing the client secret obtained in step 3
                    clientSecret: result.clientSecret,
                    // Fully customizable with appearance API.
                    appearance: {/*...*/ },
                });
                setStripeKey(result.clientKey);
        });
    }, []);

    React.useEffect(() => {
        if(stripeKey !== null && stripeKey !== ""){
        setStripePromise(loadStripe(stripeKey));
        }
    }, [stripeKey]);
    

    function getleagueSummaryContent() {
        return (
            <div className="mb-3">
                <CardContainer icon={bowl_icon}>
                    <h4 className="card-title header-league-title">{paymentIntentResult?.leagueSummary?.league.name}</h4>
                    <p className="d-none d-sm-block card-text header-league-text">{paymentIntentResult?.leagueSummary?.center?.name}</p>
                    <p className="d-none d-sm-block card-text header-league-text">{paymentIntentResult?.leagueSummary?.league.start} - {paymentIntentResult?.leagueSummary?.league.end}</p>
                    <div>
                        {paymentIntentResult?.leagueSummary?.league.duration > 1
                            && <span className="badge rounded-pill league-badge">{paymentIntentResult?.leagueSummary?.league.duration} Weeks</span>}
                        {paymentIntentResult?.leagueSummary?.league.duration == 1
                            && <span className="badge rounded-pill league-badge">{paymentIntentResult?.leagueSummary?.league.duration} Week</span>}

                        <span className="badge rounded-pill league-badge">{paymentIntentResult?.leagueSummary?.league.dayOfWeek}</span>
                        <span className="badge rounded-pill league-badge">{paymentIntentResult?.leagueSummary?.league.time}</span>
                    </div>
                </CardContainer>
            </div>
        );
    }

    function getPaymentDetails() {
        return (
            <div className="mb-lg-0 mb-3">
                <CardContainer>
                    <table className="table">
                        <thead>
                            <tr>
                                <th scope="col" style={{ width: '100%' }}>Description</th>
                                <th scope="col">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <h5>{paymentIntentResult.bowler.name} {!!paymentIntentResult.bowler.memberId ? `(${paymentIntentResult.bowler.memberId})` : ""}</h5>
                                    {paymentIntentResult.leagueSummary.league.name}
                                </td>
                                <td className='align-middle'><span className='float-end'>{currencyFormat(paymentIntentResult.leagueSummary.league.price)}</span></td>
                            </tr>
                            {paymentIntentResult.bowler.needToBuyMembership === true &&
                                <>
                                    <tr>
                                        <td>{paymentIntentResult.membershipProduct.name}</td>
                                        <td><span className='float-end'>{currencyFormat(paymentIntentResult.membershipProduct.cost)}</span></td>
                                    </tr>
                                    {
                                        paymentIntentResult.convenienceFee ?
                                            <tr>
                                                <td>Convenience Fee</td>
                                                <td><span className='float-end'>{currencyFormat(paymentIntentResult.convenienceFee)}</span></td>
                                            </tr>
                                            : ""
                                    }

                                </>
                            }
                            <tr className='table-secondary'>
                                <th>Total</th>
                                <th><span className='float-end'>{currencyFormat(paymentIntentResult.totalAmountDue)}</span></th>
                            </tr>
                        </tbody>
                    </table>
                </CardContainer>
            </div>
        );
    }

    function onPaymentConfirmed(paymentIntentId) {
        props.updateWizardState((prev) => {
            return {
                ...prev,
                paymentIntentId: paymentIntentId
            };
        })
        props.nextView();
    }

    return (
        <>
            <div>
                <div className="row">
                    <div className="col h4 wizard-step-title">
                        Review & Pay {paymentIntentResult != null ? currencyFormat(paymentIntentResult.totalAmountDue) : ''}
                    </div>
                </div>
                <LoadingComponent isLoading={() => isLoading === true} description='Loading payment form'>
                    {(paymentIntentResult != null && paymentOptions != null) &&
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-12">
                                        {getleagueSummaryContent()}
                                    </div>
                                    <div className="col-lg-12">
                                        {getPaymentDetails()}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 custom-card" style={{ minHeight: '290px' }}>
                                {
                                    paymentIntentResult?.bowler?.status == 3 ?

                                        <div className="row g-3 d-flex justify-content-center">
                                            <div className="col-md-12">
                                                <CardContainer icon={<AnimatedExclamation />}>
                                                    <h5 className="card-title"><strong>{"Bowler Found: " + paymentIntentResult.bowler.name}</strong></h5>
                                                    {<p className="card-text">{paymentIntentResult.bowler.name} ({paymentIntentResult.bowler.memberId}) is already participating in this League. Please register a different member.</p>}
                                                </CardContainer>
                                            </div>
                                        </div>
                                        :
                                        (
                                            paymentIntentResult?.bowler?.status == 4 ?

                                                <div className="row g-3 d-flex justify-content-center">
                                                    <div className="col-md-12">
                                                        <CardContainer icon={<AnimatedExclamation />}>
                                                            <h5 className="card-title"><strong>{"Bowler: " + paymentIntentResult.bowler.name}</strong></h5>
                                                            {<p className="card-text">{paymentIntentResult.bowler.name} must be 18 years of age or older to participate.</p>}
                                                        </CardContainer>
                                                    </div>
                                                </div>
                                                :
                                                <>
                                                    { stripePromise && <Elements stripe={stripePromise} options={paymentOptions}>
                                                        <CheckoutForm onPaymentConfirmed={onPaymentConfirmed} setPaymentProcessing={setPaymentProcessing} />
                                                    </Elements> }
                                                </>
                                        )
                                }
                            </div>
                        </div>
                    }
                </LoadingComponent>
            </div>
            <div className='wizard-buttons-container'>
                <button type="button" className="btn btn-primary bowl-btn" onClick={props.backView} disabled={paymentProcessing === true}>Back</button>
                {(paymentIntentResult?.bowler?.status != 3 && paymentIntentResult?.bowler?.status != 4) &&
                    <LoadingButton type="submit" form='paymentForm' className="btn btn-primary pay-btn" loadingText='Processing Payment' loading={paymentProcessing}>
                        Pay
                    </LoadingButton>
                }
            </div>
        </>
    )
}

export default ReviewAndPay